const MyProfileLinks = {
  myHome:{
    link:""
  },
  myRecentlyViewed: {
    link: "listings/demand/recently-viewed",
  },
  myRecentSearch: {
    link: "listings/searches/recent-search",
  },
  myAdsFollowings: {
    link: "listings/demand/following-listings",
  },
  myChats: {
    link: "chats"
  }, myNotifications: {
    link: "notifications"
  },
  myAds: {
    link: "listings/my-listings"
  },
  myDraft: {
    link: "listings/my-listings/draft-listings"
  },
  myFavAds: {
    link: "listings/demand/favorite-listings"
  },
  myJobApplications: {
    link: "listings/demand/job-applications"
  },
  mySavedSearch: {
    link: "listings/searches/saved-search"
  },
  myAccount: {
    link: "account/my-account"
  }, myCv: {
    link: "account/cv/view"
  }, myRating: {
    link: "account/my-rating"
  },
  myWallet: {
    link: "account/my-wallet"
  }, myFollowers: {
    link: "account/followers"
  }, myAccountFollowing: {
    link: "account/following"
  }, mySettings: {
    link: "account/settings"
  }, myProducts: {
    link: "products"
  }, myInviteFriends: {
    link: "invite-friends"
  },


}

export {MyProfileLinks};
